export interface Environment {
  apiUrl: string;
  environment: 'development' | 'staging' | 'production';
  toastApiUrl?: string;
  debug: boolean;
}

const getEnvironment = (): Environment => {
  const env = process.env.REACT_APP_ENVIRONMENT || 'development';

  return {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080',
    toastApiUrl: process.env.REACT_APP_TOAST_API_URL || '',
    environment: env as 'development' | 'staging' | 'production',
    debug: process.env.REACT_APP_DEBUG === 'true' || env === 'development',
  };
};

export const environment = getEnvironment();
